// Third-party integrations in lib/date-integration are special exceptions
// and can use the Date class for communication with the external API.
/* eslint-disable no-restricted-globals -- Date */
import { DayObject, DayRange } from "@/types/date"
import { DateRange as InternalDateRange } from "@daypicker/react"

// The third-party DayPicker component that we're using only works
// in browser local time, so when it gives us a raw Date object, we
// IGNORE the timestamp that it represents and only look at its
// year/month/day and create a DayObject to hand back in our callbacks.
export function convertFromInternalDate(date: Date): DayObject {
  return {
    year: date.getFullYear(),
    month: 1 + date.getMonth(),
    day: date.getDate(),
  }
}

// ... and vice-versa.
export function convertToInternalDate(
  day: DayObject | undefined
): Date | undefined {
  return day && new Date(day.year, day.month - 1, day.day)
}

export function convertToInternalRange(range: DayRange): InternalDateRange {
  return {
    from: range.from && convertToInternalDate(range.from),
    to: range.to && convertToInternalDate(range.to),
  }
}

export function wrapCallback(
  callback: (day: DayObject | undefined) => void
): (date: Date | undefined) => void {
  return (date: Date | undefined) =>
    callback(date && convertFromInternalDate(date))
}
